export const CALCULUS = 'Calculus I'
export const MICROECONOMICS = 'Introduction to Microeconomics'
export const MACROECONOMICS = 'Introduction to Macroeconomics'
export const PRECALCULUS = 'Precalculus'
export const PRINCIPLES_OF_ECONOMICS = 'Principles of Economics'
export const COLLEGE_ALGEBRA = 'College Algebra'
export const COLLEGE_WRITING_II = 'College Writing II'
